import React from 'react';
import Slider from '../Slider';

// Use the same live slider editor here so every saved change reaches the
// customer website through the shared appearance slider API.
const SliderView = (props) => <Slider {...props} />;

export default SliderView;
